import React, {ReactElement} from 'react';
import {FormattedMessage} from 'react-intl';
import {cx} from '@emotion/css';
import {LinkProp} from '@fo/shared-types';
import DynamicLink from '@fo/components/DynamicLink/DynamicLink';
import {fonts} from '@fo/shared/styles/variables';
import Headers, {HeaderType} from '@fo/designSystem/Text/Headers/Headers';
import sortByLabel from './sortByLabel';
import {RelatedArticlesBackgroundColor} from './types';

import styles from './RelatedArticles.styles';

export {RelatedArticlesBackgroundColor} from './types';

interface Props {
  backgroundColor?: RelatedArticlesBackgroundColor;
  links: LinkProp[];
  className?: string;
  noSorting?: boolean;
}

function RelatedArticles({backgroundColor, links, className, noSorting}: Props): ReactElement {
  const sortedLinks: LinkProp[] = noSorting ? links : sortByLabel(links);

  return (
    <div className={cx(styles.componentWrapper(backgroundColor), className)}>
      <Headers headerType={HeaderType.H3} alignment={fonts.alignment.LEFT} className={cx(styles.title)}>
        <FormattedMessage id="phoenix.relatedArticles.label" />
      </Headers>
      <div className={cx(styles.linkWrap)}>
        {sortedLinks.map((link) => (
          <DynamicLink key={link.label} href={link.href} className={cx(styles.link)}>
            {link.label}
          </DynamicLink>
        ))}
      </div>
    </div>
  );
}

export default RelatedArticles;
